module.exports = __webpack_public_path__ + "media/images/yardstick-ruler-black-e89e682aca484890e26104d56902ec4f.png";